module.exports = __webpack_public_path__ + "static/media/x-ray.cb2d8b17.svg";